import { styled } from 'styled-components';

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 380px;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;
